var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location_Icon",
    "data-name": "Location Icon",
    transform: "translate(11704 5677)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    cx: 38,
    cy: 38,
    r: 38,
    transform: "translate(-11704 -5677)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(-11696 -5669)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_328",
    "data-name": "Ellipse 328",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(-11688 -5661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "location_on-24px_2_",
    "data-name": "location_on-24px (2)",
    transform: "translate(-11678 -5651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21441",
    "data-name": "Path 21441",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21442",
    "data-name": "Path 21442",
    d: "M12,2A7,7,0,0,0,5,9c0,5.25,7,13,7,13s7-7.75,7-13A7,7,0,0,0,12,2Zm0,9.5A2.5,2.5,0,1,1,14.5,9,2.5,2.5,0,0,1,12,11.5Z",
    fill: "#0053a5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/Locationicon.3cf43b4c0f8b2a17a80be16978f444d7.svg";
export { ForwardRef as ReactComponent };